import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuLateralComponent } from './menu-lateral.component';

@NgModule({
	declarations: [],
	imports: [MenuLateralComponent],
	exports: [MenuLateralComponent],
})
export class MenuLateralModule {}
